var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        { attrs: { disabled: _vm.formDisabled } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: {
                slot: "detail",
                model: _vm.model,
                rules: _vm.validatorRules
              },
              slot: "detail"
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "防疫指挥部",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "name"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入防疫指挥部" },
                            model: {
                              value: _vm.model.name,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "name", $$v)
                              },
                              expression: "model.name"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "选择厂区",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "factoryIds"
                          }
                        },
                        [
                          _c("j-multi-select-tag", {
                            attrs: {
                              type: "select",
                              options: _vm.factoryOptions,
                              allowClear: ""
                            },
                            on: { change: _vm.handleFactoryChange },
                            model: {
                              value: _vm.model.factoryIds,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "factoryIds", $$v)
                              },
                              expression: "model.factoryIds"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "系统账号",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "principalId"
                          }
                        },
                        [
                          _c("a-select", {
                            attrs: {
                              placeholder: "请选择系统账号",
                              options: _vm.sysAccountOptions,
                              allowClear: ""
                            },
                            on: { change: _vm.handleAccoutChange },
                            model: {
                              value: _vm.model.principalId,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "principalId", $$v)
                              },
                              expression: "model.principalId"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "负责人工号",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "employeeNo"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder: "请输入负责人工号",
                              disabled: ""
                            },
                            model: {
                              value: _vm.model.employeeNo,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "employeeNo", $$v)
                              },
                              expression: "model.employeeNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "负责人姓名",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "principalName"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder: "请输入负责人姓名",
                              disabled: ""
                            },
                            model: {
                              value: _vm.model.principalName,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "principalName", $$v)
                              },
                              expression: "model.principalName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "邮箱",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "principalEmail"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入邮箱" },
                            model: {
                              value: _vm.model.principalEmail,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "principalEmail", $$v)
                              },
                              expression: "model.principalEmail"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "座机",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "principalLandline"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入座机" },
                            model: {
                              value: _vm.model.principalLandline,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "principalLandline", $$v)
                              },
                              expression: "model.principalLandline"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "手机",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "principalMobile"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入手机" },
                            model: {
                              value: _vm.model.principalMobile,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "principalMobile", $$v)
                              },
                              expression: "model.principalMobile"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "是否立即启用",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "status"
                          }
                        },
                        [
                          _c("j-switch", {
                            model: {
                              value: _vm.model.status,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "status", $$v)
                              },
                              expression: "model.status"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }